import type { ICommercialLink } from 'shared/types/commercialLinks';
import type { TApplicationState } from 'shared/types/redux';

export const selectCommercialLinks = (state: TApplicationState): ICommercialLink[] => state.commercialLinks;
